import { createSlice } from '@reduxjs/toolkit'
import type { InitializationState } from './types'

export const initialState: InitializationState = {
  initialized: false,
}

const initializationSlice = createSlice({
  name: 'initialization',
  initialState,
  reducers: {
    // Triggers the initialization saga
    initialize: (state) => state,
    // Called when initialization is complete
    setInitialized: (state) => {
      state.initialized = true
    },
    // Resets initialization so the initialize saga can run again (e.g. after logout)
    resetInitialized: (state) => {
      state.initialized = false
    },
  },
})

export const initializationActions = initializationSlice.actions
export default initializationSlice.reducer
